<template>
    <div class="credit-card-existing-form">
        <transition name="fade" mode="out-in">
            <div v-if="!isEditing" key="view">
                <CreditCardView
                    :upgrade-option="true"
                    @switch-to-upgrade="() => onEditChange(true)"
                />

                <div v-if="error" class="form-error">
                    {{ error }}
                </div>
            </div>

            <div v-if="isEditing" key="create">
                <CreditCardNewForm
                    :error="error"
                    :on-mount="onMount"
                >
                    <template #link>
                        <a
                            href="#"
                            class="return-link"
                            @click="() => onEditChange(false)"
                        >
                            Cancel
                        </a>
                    </template>
                </CreditCardNewForm>
            </div>
        </transition>
    </div>
</template>
<script>
import CreditCardNewForm from '@/components/Billing/CreditCardNewForm';
import CreditCardView from '@/components/Dashboard/Settings/Billing/CardBox';

export default {
    components: {
        CreditCardNewForm,
        CreditCardView,
    },

    props: {
        error: {
            type: String,
            default: null,
        },
        isEditing: {
            type: Boolean,
            required: true,
        },
        onEditChange: {
            type: Function,
            required: true,
        },
        onMount: {
            type: Function,
            default: null,
        },
    },
};
</script>
<style scoped lang="scss">
    @use './CreditCardExistingForm.scss';
</style>
